"use client";
import React, { useLayoutEffect, useRef, useState } from "react";
import LayerVisualItem from "./LayerVisualItem";
import Reveal from "../../components/Reveal";
import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { useTranslations } from "next-intl";

type Award = {
  id: string;
  title: string;
  subTitle: React.ReactNode;
  bg: string;
  imgUrl: string;
};

const Award = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const viewportRef = useRef<HTMLDivElement>(null);
  const [progress, setProgress] = useState(0);
  const t = useTranslations("invester");
  const awards: Award[] = [
    // {
    //   id: "a",
    //   title: "WITSA Global Awards 2025 - Chairman's Award",
    //   subTitle: t.rich(
    //     "hyra-network-was-recognized-for-decentralized-ai-infrastructure-for-the-sovereign-digital-era-presented-on-august-19-2025-in-taipei-taiwan-and-signed-by-dato-dr-sean-seah-chairman-of-witsa",
    //     {
    //       bold: (chunks) => (
    //         <strong className="font-semibold text-black">{chunks}</strong>
    //       ),
    //     }
    //   ),
    //   bg: "#6E19EB",
    //   imgUrl: "/images/icons/award-chairman.png"
    // },
    {
      id: "b",
      title: "Globee® Awards 2025 – Gold Winner (Technology)",
      subTitle: t.rich(
        "hyra-network-named-technology-startups-of-the-year-for-its-decentralized-ai-infrastructure-powering-global-edge-computing-with-2m-users",
        {
          bold: (chunks) => (
            <strong className="font-semibold text-black">{chunks}</strong>
          ),
        },
      ),
      bg: "#599EFF",
      imgUrl: "/images/icons/award-chairman2.svg",
    },
    {
      id: "c",
      title: "Vietnam Technology Excellence Awards 2025 – Recognition",
      subTitle: t.rich(
        "hyra-network-was-recognized-at-the-vietnam-technology-excellence-awards-2025-a-program-under-the-asian-technology-excellence-awards-by-asian-business-review-honoring-standout-technology-innovations-delivering-real-impact-across-vietnam",
        {
          bold: (chunks) => (
            <strong className="font-semibold text-black">{chunks}</strong>
          ),
        },
      ),
      bg: "#06F",
      imgUrl: "/images/icons/award-chairman3.svg",
    },
  ];

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const section = sectionRef.current!;
      const mm = gsap.matchMedia();

      // Pin viewport như sticky top:0 trong khoảng mong muốn
      //   ScrollTrigger.create({
      //     trigger: section,
      //     pin: true,
      //     start: "top 20px",
      //     // end: "bottom top", // chỉnh theo số card
      //     end: () => `+=${window.innerHeight * 3}`,
      //     scrub: true,
      //     anticipatePin: 1,
      //     invalidateOnRefresh: true,
      //     // markers: true,
      //   });

      //   // Đo progress số 0..1 trên toàn section
      //   ScrollTrigger.create({
      //     trigger: section,
      //     start: "top bottom",
      //     end: () => `+=${window.innerHeight * 3}`,
      //     scrub: true,
      //     onUpdate: (self) => setProgress(self.progress),
      //   });
      // }, sectionRef);

      // Desktop / tablet (md trở lên)
      mm.add("(min-width: 768px)", () => {
        ScrollTrigger.create({
          trigger: section,
          pin: true,
          start: "top 20px", // desktop có khoảng hở 20px
          end: () => `+=${window.innerHeight * 3}`,
          scrub: true,
          anticipatePin: 1,
          invalidateOnRefresh: true,
        });

        ScrollTrigger.create({
          trigger: section,
          start: "top bottom",
          end: () => `+=${window.innerHeight * 3}`,
          scrub: true,
          onUpdate: (self) => setProgress(self.progress),
        });
      });

      // Mobile (sm)
      mm.add("(max-width: 767px)", () => {
        ScrollTrigger.create({
          trigger: section,
          pin: true,
          start: "top -30px", // hoặc "top 0px", "top -10px"
          end: () => `+=${window.innerHeight * 3}`,
          scrub: true,
          anticipatePin: 1,
          invalidateOnRefresh: true,
        });

        ScrollTrigger.create({
          trigger: section,
          start: "top bottom",
          end: () => `+=${window.innerHeight * 3}`,
          scrub: true,
          onUpdate: (self) => setProgress(self.progress),
        });
      });
    }, sectionRef);

    return () => {
      ctx.revert();
      ScrollTrigger.getAll().forEach((st) => st.kill());
    };
  }, []);

  return (
    <section ref={sectionRef} className="relative min-h-[100vh]">
      <div
        ref={viewportRef}
        className="sticky top-0 min-h-screen overflow-hidden px-4 md:px-20"
      >
        {/* Header */}
        <div className="mt-10 flex min-h-[350px] items-center justify-center">
          <div className="absolute left-1/2 top-0 -z-10 h-[350px] w-[500px] -translate-x-1/2 overflow-hidden">
            <video
              autoPlay
              loop
              muted
              playsInline
              className="scale-105 object-cover object-center [-webkit-mask-image:linear-gradient(to_right,transparent,black_30%,black_100%)] [mask-image:linear-gradient(to_right,transparent,black_30%,black_100%)]"
              style={{
                WebkitMaskImage:
                  "radial-gradient(ellipse at center, rgba(0,0,0,1) 50%, transparent 100%)",
                WebkitMaskRepeat: "no-repeat",
                WebkitMaskPosition: "center",
                WebkitMaskSize: "cover",
                maskImage:
                  "radial-gradient(ellipse at center, rgba(0,0,0,1) 50%, transparent 100%)",
                maskRepeat: "no-repeat",
                maskPosition: "center",
                maskSize: "cover",
              }}
            >
              <source
                src="https://cdn-r2.hyra.network/hyra-network/Cup.webm"
                type="video/webm"
              />
            </video>
          </div>
          <div className="text-center">
            {/* <Reveal
              delay={0.1}
              duration={0.8}
              direction="left"
              withBlur={true}
              blurAmount={8}
            > */}
            <h2 className="text-[48px]/[56px] tracking-[-1px] text-[#202020] max-sm:text-[32px]/[40px]">
              {t("awards")}
            </h2>
            {/* </Reveal> */}

            {/* <Reveal
              delay={0.1}
              duration={0.8}
              direction="left"
              withBlur={true}
              blurAmount={8}
            > */}
            <p className="mt-6 text-base font-light text-[#646464] max-sm:text-sm">
              {t("global-recognition-from-leading-tech-and-business-awards")}
            </p>
            {/* </Reveal> */}
          </div>
        </div>

        {/* Cards */}
        <div className="relative mx-auto mt-10 flex min-h-[550px] flex-col items-center justify-center max-lg:-mt-10">
          {awards.map((_, index) => (
            <LayerVisualItem
              key={index}
              index={index}
              awards={awards}
              scrollYProgress={progress}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Award;
